import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "../modal";
import SelectDropdownSecondaryComponent from "../select-dropdown-secondary";
import ButtonComponent from "../button";
import { useFormik } from "formik";
import { ruleEngineSchema } from "../../helpers/schemas";
import { useLocation } from "react-router";
import TextareaComponent from "../textarea";
import { toast } from "react-toastify";
import { ActionsContainer, Form, FormError, ConfigurationWrapper, FieldContainer, FieldSection, FieldWrapper, FieldActions, IncreaseDecreaseActions, Label, EmptyWrapper, ConfiguredTag, TableWrapper } from "./add-update-rule-engine-modal.style";
import IconButtonComponent from "../icon-button";
import { CheckRoundedFillSvg, ListSettingSvg, MinusSvg, PencilSvg, PlusSvg } from "../../assets/svgs";
import TransferListCheckbox from "../transfer-list-checkbox";
import { HorizontalLine } from "../../styles/global-styles";
import AddUpdateRuleConfigurationModal from "../add-update-rule-configuration-modal";
import EmptyModalComponent from "../empty-modal";
import { getAllBinsByInstitution } from "../../redux/slices/rule-engine-slice";
import { ruleEngineConstant } from "../../constants/app-constants";
import TableComponent from "../table";
// import BadgeComponent from "../badge";
import moment from "moment";
import MultiSelectDropdownComponent from "../multi-select-dropdown";
import { providerInstitutionConstant } from "../../constants/user-constants";

const AddUpdateRuleEngineModal = ({ data, close, label, handleFormSubmit, viewOnly, update, fromMakerChecker, emptyConfigurations, slide }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { schemes } = useSelector((state) => state.schemesListReducer);

    const { binsListByInstitution, countryList } = useSelector((state) => state.ruleEngineReducer);

    // const notProvider = (user?.institution?.id !== providerInstitutionConstant?.id) && (!user?.superAdmin);
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);
    const isChecker = location.pathname.includes('checker');
    const isDisabledAll = isChecker || viewOnly;

    const [binsList, setBinsList] = useState([]);
    const [hasChanges, setHasChanges] = useState(false);

    const [configuredBins, setConfiguredBins] = useState([]);
    const [selectedConfigurationIndex, setSelectedConfigurationIndex] = useState(null);
    const [isOpenConfigurationModal, setIsOpenConfigurationModal] = useState(false);

    const { handleChange, handleBlur, handleSubmit, setFieldValue, values, validateForm, touched, errors, dirty } = useFormik({
        initialValues: data,
        validationSchema: ruleEngineSchema({ fromMakerChecker, isChecker }),
        onSubmit: fromMakerChecker ? () => { } : (payload) => {

            if (hasChanges) {
                const updatedPayload = {
                    institutionId: values?.institution,
                    institutionRuleStatus: true,
                    institutionBinRanges: values?.configurations?.map((config) =>
                        config?.bins?.map(bin => ({
                            binRangeId: bin?.value,
                            bin: bin?.label,
                            rulesConfiguration: {
                                numberOfDays: [
                                    { risk: 'LOW', value: config?.numberOfDaysLow },
                                ],
                                numberOfSuccessfullTransaction: [
                                    { risk: 'LOW', value: config?.numberOfSuccessfullTransactionLow, score: config?.numberOfSuccessfullTransactionLowScore },
                                    { risk: 'MEDIUM', value: config?.numberOfSuccessfullTransactionMedium, score: config?.numberOfSuccessfullTransactionMediumScore },
                                    { risk: 'HIGH', value: config?.numberOfSuccessfullTransactionHigh, score: config?.numberOfSuccessfullTransactionHighScore }
                                ],
                                purchaseAmount: [
                                    { risk: 'LOW', value: config?.purchaseAmountLow, score: config?.purchaseAmountLowScore },
                                    { risk: 'MEDIUM', value: config?.purchaseAmountMedium, score: config?.purchaseAmountMediumScore },
                                    { risk: 'HIGH', value: config?.purchaseAmountHigh, score: config?.purchaseAmountHighScore }
                                ],
                                deviceFingerPrintScore: config?.deviceFingerPrintScore,
                                currencies: config?.currencies,
                                currencyCodeScore: config?.currencyCodeScore,
                                effectiveDateTime: config?.effectiveDateTime
                            },
                            ruleScoreMatrix: {
                                frictionlessScoreThreshold: config?.frictionlessScoreThreshold || "",
                            },
                            rulesWeitage: {
                                numberOfSuccessfullTransactionWeitage: config?.numberOfSuccessfullTransactionWeitage || "",
                                purchaseAmountWeitage: config?.purchaseAmountWeitage || "",
                                deviceFingerPrintWeitage: config?.deviceFingerPrintWeitage || "",
                                currencyCodeWeitage: config?.currencyCodeWeitage || "",
                            },
                            rulesOperator: {
                                numberOfSuccessfullTransaction: "Greater-equal",
                                numberOfDays: "Greater-equal",
                                purchaseAmount: "Less-equal"
                            }
                        }))
                    ).flat()
                };
                handleFormSubmit(updatedPayload);
            } else {
                toast.info('No changes found');
            }
        },
    });

    const handleAcceptReject = async (isAccept) => {
        const formErrors = await validateForm();

        if (Object.keys(formErrors).length < 1) {
            const ruleEngineRules = {
                institutionId: values?.institution,
                institutionRuleStatus: values?.institutionRuleStatus,
                institutionBinRanges: values?.configurations?.map((config) =>
                    config?.bins?.map(bin => ({
                        binRangeId: bin?.value,
                        bin: bin?.label,
                        rulesConfiguration: {
                            numberOfDays: [
                                { risk: 'LOW', value: config?.numberOfDaysLow || "" },
                            ],
                            numberOfSuccessfullTransaction: [
                                { risk: 'LOW', value: config?.numberOfSuccessfullTransactionLow || "", score: config?.numberOfSuccessfullTransactionLowScore || "" },
                                { risk: 'MEDIUM', value: config?.numberOfSuccessfullTransactionMedium || "", score: config?.numberOfSuccessfullTransactionMediumScore || "" },
                                { risk: 'HIGH', value: config?.numberOfSuccessfullTransactionHigh || "", score: config?.numberOfSuccessfullTransactionHighScore || "" }
                            ],
                            purchaseAmount: [
                                { risk: 'LOW', value: config?.purchaseAmountLow || "", score: config?.purchaseAmountLowScore || "" },
                                { risk: 'MEDIUM', value: config?.purchaseAmountMedium || "", score: config?.purchaseAmountMediumScore || "" },
                                { risk: 'HIGH', value: config?.purchaseAmountHigh || "", score: config?.purchaseAmountHighScore || "" }
                            ],
                            deviceFingerPrintScore: config?.deviceFingerPrintScore || "",
                            currencies: config?.currencies || [],
                            currencyCodeScore: config?.currencyCodeScore || "",
                            effectiveDateTime: config?.effectiveDateTime
                        },
                        ruleScoreMatrix: {
                            frictionlessScoreThreshold: config?.frictionlessScoreThreshold || "",
                        },
                        rulesWeitage: {
                            numberOfSuccessfullTransactionWeitage: config?.numberOfSuccessfullTransactionWeitage || "",
                            purchaseAmountWeitage: config?.purchaseAmountWeitage || "",
                            deviceFingerPrintWeitage: config?.deviceFingerPrintWeitage || "",
                            currencyCodeWeitage: config?.currencyCodeWeitage || "",
                        },
                        rulesOperator: config?.rulesOperator,
                    }))
                ).flat()
            };

            handleFormSubmit({
                isaccepted: isAccept,
                ruleEngineRules,
                reason: values?.reason,
            });
        } else {
            handleSubmit();
        }
    };

    const handleSetConfiguration = (index) => {
        setSelectedConfigurationIndex(index);
        setIsOpenConfigurationModal(true);
    };

    const handleConfigurationSubmit = (payload) => {
        const updatedConfigurations = [...values.configurations];
        updatedConfigurations[selectedConfigurationIndex] = { ...payload, isConfigured: ruleEngineConstant?.isConfigured };
        setFieldValue('configurations', updatedConfigurations);
        setIsOpenConfigurationModal(false);
    };

    const toggleObject = (type, name, array, object, index) => {
        if (!viewOnly) {
            if (type === 'add') {
                setFieldValue(name, [...array, object]);
            } else if (type === 'remove') {
                if (array.length > 1) {
                    if (index !== undefined && index !== null) {
                        setFieldValue(name, array.filter((_, i) => i !== index));
                    } else {
                        setFieldValue(name, array.slice(0, -1));
                    }
                    setConfiguredBins(configuredBins.filter(bin => !values?.configurations?.some(config => config?.bins?.some(b => b.value === bin.value))));
                }
            }
        }
    };

    useEffect(() => {
        setHasChanges(dirty);
    }, [dirty]);

    useEffect(() => {
        if (values?.institution && values?.institution !== '') {
            if (!viewOnly && !update) {
                setFieldValue('configurations', [emptyConfigurations]);
                setConfiguredBins([]);
            }
            dispatch(getAllBinsByInstitution({ user, id: values?.institution }));
        }
    }, [values?.institution]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (binsListByInstitution && Array.isArray(binsListByInstitution)) {
            if (configuredBins && Array.isArray(configuredBins) && configuredBins?.length > 0) {
                setBinsList(binsListByInstitution.filter(bin => !configuredBins.some(b => b.label === bin.label)));
            } else {
                setBinsList(binsListByInstitution);
            }
        }
    }, [configuredBins, binsListByInstitution]);

    const columns = [
        {
            field: 'bins',
            headerName: 'Configured Bins',
            sortable: false,
            width: 180,
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.bins && row?.bins?.length > 0 && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px' }}>
                                    {
                                        row?.bins?.map((bin, index) => (
                                            <Fragment key={index}>
                                                {bin?.label}
                                                {/* {bin?.scheme?.label && (
                                                    <BadgeComponent
                                                        label={bin?.scheme?.label}
                                                        type="default"
                                                        outline
                                                    />
                                                )} */}
                                                {bin?.scheme?.logo && (
                                                    <img src={bin?.scheme?.logo} alt={bin?.scheme?.label} style={{ width: '100%', maxWidth: 30, height: 'auto' }} />
                                                )}
                                                {index < row.bins.length - 1 && ', '}
                                            </Fragment>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </>
                )
            },
        },
        {
            field: 'numberOfSuccessfullTransaction',
            headerName: 'Transaction History',
            width: 180,
            align: 'center',
            sortable: false,
            valueGetter: (row) => {
                if (!isDisabledAll) return '';
                const numberOfSuccessfullTransaction = row?.numberOfSuccessfullTransaction;
                if (Array.isArray(numberOfSuccessfullTransaction) && numberOfSuccessfullTransaction.length > 0) {
                    return numberOfSuccessfullTransaction.map(item => `${item.risk}: ${item.value}, ${` Score`}: ${item.score}%`).join(', ').replace(/\b\w/g, c => c.toUpperCase());
                }
                return numberOfSuccessfullTransaction || '';
            }
        },
        {
            field: 'purchaseAmount',
            headerName: 'Amount Threshold',
            width: 180,
            align: 'center',
            sortable: false,
            valueGetter: (row) => {
                if (!isDisabledAll) return '';
                const purchaseAmount = row?.purchaseAmount;
                if (Array.isArray(purchaseAmount) && purchaseAmount.length > 0) {
                    return purchaseAmount.map(item => `${item.risk}: ${item.value}, ${` Score`}: ${item.score}%`).join(', ');
                }
                return purchaseAmount || '';
            }
        },
        {
            field: 'deviceFingerPrintScore',
            headerName: 'Device Fingerprint Score',
            width: 150,
            align: 'center',
            valueGetter: (row) => {
                return `${row?.deviceFingerPrintScore}%` || '';
            },
            sortBy: (row) => Number(row?.deviceFingerPrintScore),
        },
        {
            field: 'currencies',
            headerName: 'Currencies',
            width: 150,
            align: 'center',
            sortable: false,
            valueGetter: (row) => {
                return Array.isArray(row?.currencies) ? row?.currencies?.map(currency => countryList.find(c => c.currencyCode === currency)?.currency).join(', ') : '';
            }
        },
        {
            field: 'currencyCodeScore',
            headerName: 'Currency Score',
            width: 150,
            align: 'center',
            valueGetter: (row) => {
                return `${row?.currencyCodeScore}%` || '';
            },
            sortBy: (row) => Number(row?.currencyCodeScore),
        },
        {
            field: 'currencyCodeWeitage', headerName: 'Currency Code Weightage', width: 150, align: 'center',
            valueGetter: (row) => {
                return `${row?.currencyCodeWeitage}%` || '';
            },
            sortBy: (row) => Number(row?.currencyCodeWeitage),
        },
        {
            field: 'deviceFingerPrint', headerName: 'Device Fingerprint Weightage', width: 150, align: 'center',
            valueGetter: (row) => {
                return `${row?.deviceFingerPrintWeitage}%` || '';
            },
            sortBy: (row) => Number(row?.deviceFingerPrintWeitage),
        },
        {
            field: 'numberOfSuccessfullTransactionWeitage', headerName: 'Transaction History Weightage', width: 150, align: 'center',
            valueGetter: (row) => {
                return `${row?.numberOfSuccessfullTransactionWeitage}%` || '';
            },
            sortBy: (row) => Number(row?.numberOfSuccessfullTransactionWeitage),
        },
        {
            field: 'purchaseAmountWeitage', headerName: 'Amount Threshold Weightage', width: 150, align: 'center',
            valueGetter: (row) => {
                return `${row?.purchaseAmountWeitage}%` || '';
            },
            sortBy: (row) => Number(row?.purchaseAmountWeitage),
        },
        {
            field: 'numberOfDays',
            headerName: 'Number of Days',
            width: 150,
            align: 'center',
            valueGetter: (row) => {
                if (!isDisabledAll) return '';
                const numberOfDays = row?.numberOfDays;
                if (Array.isArray(numberOfDays) && numberOfDays.length > 0) {
                    return numberOfDays.map(item => `${item.value}`).join(', ');
                }
                return numberOfDays || '';
            },
            sortBy: (row) => Number(row?.numberOfDays?.[0]?.value || 0),
        },
        {
            field: 'frictionlessScoreThreshold',
            headerName: 'Frictionless Score Threshold',
            width: 200,
            align: 'center',
            valueGetter: (row) => {
                return row?.frictionlessScoreThreshold || row?.ruleScoreMatrix?.frictionlessScoreThreshold || '';
            },
            sortBy: (row) => Number(row?.frictionlessScoreThreshold || row?.ruleScoreMatrix?.frictionlessScoreThreshold || 0),
        },
        {
            field: 'effectiveDateTime', headerName: 'Effective Date Time', width: 150, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.effectiveDateTime && (
                                <>
                                    {moment(row?.effectiveDateTime).format('MMMM Do YYYY, h:mm a')}
                                </>
                            )
                        }
                    </>
                )
            },
            sortBy: (row) => row?.effectiveDateTime,
        },
    ];

    return (
        <>
            <ModalComponent close={close} label={label} width={isDisabledAll ? 1200 : 900} slide={slide}>
                {/* MODAL BODY */}
                <Form onSubmit={handleSubmit}>
                    <FieldWrapper>
                        <FieldContainer>
                            <FieldSection $compact={true}>
                                {/* <Label>Institution</Label> */}
                                <SelectDropdownSecondaryComponent
                                    label='Institution'
                                    options={institutionsWithID}
                                    name="institution"
                                    value={values.institution}
                                    onChange={handleChange}
                                    disabled={isDisabledAll || update || !isProvider}
                                    mui
                                />
                                {
                                    touched.institution && errors.institution && (
                                        <FormError>{errors.institution}</FormError>
                                    )
                                }
                            </FieldSection>
                        </FieldContainer>
                        {
                            values?.institution && binsListByInstitution && binsListByInstitution?.length > (update ? 0 : 1) && emptyConfigurations && !isDisabledAll && (
                                (() => {
                                    const isConfigured = values?.configurations?.[values?.configurations?.length - 1]?.isConfigured === ruleEngineConstant?.isConfigured;
                                    const isDisabledAdd = !(configuredBins?.length > 0 && binsList?.length > 0 && isConfigured);
                                    const isDisabledRemove = !configuredBins?.length > 0 || values?.configurations?.length === 1;

                                    return (
                                        <IncreaseDecreaseActions>
                                            <IconButtonComponent icon={MinusSvg} type='button' outline onClick={() => toggleObject('remove', 'configurations', values.configurations, emptyConfigurations)} disabled={isDisabledRemove} />
                                            <IconButtonComponent icon={PlusSvg} type='button' onClick={() => toggleObject('add', 'configurations', values.configurations, emptyConfigurations)} disabled={isDisabledAdd} />
                                        </IncreaseDecreaseActions>
                                    )
                                })()
                            )
                        }
                    </FieldWrapper>

                    {
                        (values?.institution && values?.configurations && values?.configurations?.length > 0) ? (
                            <>
                                {
                                    isDisabledAll ? (
                                        <TableWrapper>
                                            <TableComponent rows={values?.configurations} columns={columns} icon={ListSettingSvg} />
                                        </TableWrapper>
                                    ) : (
                                        <ConfigurationWrapper className="custom-scrollbar" $fromMakerChecker={fromMakerChecker}>
                                            {
                                                values?.configurations?.map((_, index) => {
                                                    const scheme = values?.configurations?.[index]?.scheme;
                                                    const filteredBins = (!scheme || scheme?.length === 0) ? binsList : binsList.filter(bin => scheme.includes(bin?.scheme?.value));

                                                    const isConfigured = values?.configurations?.[index]?.isConfigured;

                                                    if (isConfigured === ruleEngineConstant?.isConfigured && !configuredBins.some(bin => values?.configurations?.[index]?.bins?.some(b => b.value === bin.value))) {
                                                        setConfiguredBins((old) => {
                                                            const newBins = values?.configurations?.[index]?.bins?.filter(
                                                                bin => !old.some(oldBin => oldBin.value === bin.value)
                                                            );
                                                            return [...old, ...newBins];
                                                        });
                                                    }

                                                    return (
                                                        <Fragment key={index}>
                                                            <FieldWrapper>
                                                                <FieldContainer>
                                                                    {/* select scheme */}
                                                                    <FieldSection $compact={true}>
                                                                        {/* <Label>
                                                                            <FilterSvg />
                                                                            Scheme
                                                                        </Label> */}
                                                                        {/* <SelectDropdownSecondaryComponent
                                                                            options={[{ label: 'All', value: '' }, ...schemes?.map(({ name, id }) => ({ label: name, value: id }))]}
                                                                            name={`configurations.${index}.scheme`}
                                                                            value={values.configurations[index].scheme}
                                                                            onChange={handleChange}
                                                                        /> */}
                                                                        <MultiSelectDropdownComponent
                                                                            label='Filter Scheme'
                                                                            options={[...schemes?.map(({ name, id }) => ({ label: name, value: id }))]}
                                                                            name={`configurations.${index}.scheme`}
                                                                            value={values.configurations[index].scheme}
                                                                            onChange={handleChange}
                                                                            mui
                                                                        />
                                                                        {
                                                                            touched.configurations?.[index]?.scheme && errors.configurations?.[index]?.scheme && (
                                                                                <FormError>{errors.configurations[index].scheme}</FormError>
                                                                            )
                                                                        }
                                                                    </FieldSection>
                                                                    {/* select bins */}
                                                                    <FieldSection>
                                                                        <Label>Bin selection</Label>
                                                                        <TransferListCheckbox
                                                                            data={filteredBins}
                                                                            name={`configurations.${index}.bins`}
                                                                            value={values.configurations[index].bins}
                                                                            onChange={handleChange}
                                                                            disabled={isConfigured === ruleEngineConstant?.isConfigured}
                                                                            update={update}
                                                                        />
                                                                        {
                                                                            touched.configurations?.[index]?.bins && errors.configurations?.[index]?.bins && (
                                                                                <FormError>{errors.configurations[index].bins}</FormError>
                                                                            )
                                                                        }
                                                                    </FieldSection>
                                                                </FieldContainer>
                                                                <FieldActions>
                                                                    {
                                                                        isConfigured === ruleEngineConstant?.isConfigured ? (
                                                                            <>
                                                                                <ConfiguredTag label='Configured' icon={CheckRoundedFillSvg} color="success" fullWidth />
                                                                                <ButtonComponent icon={PencilSvg} label='Update' type='button' outline fullWidth onClick={() => handleSetConfiguration(index)} disabled={values?.configurations?.[index]?.bins?.length === 0} />
                                                                                {
                                                                                    values.configurations.length > 1 && !fromMakerChecker &&
                                                                                    <ButtonComponent label='Remove' type='button' outline fullWidth color='error' onClick={() => toggleObject('remove', 'configurations', values.configurations, emptyConfigurations, index)} disabled={values?.configurations?.[index]?.bins?.length === 0} />
                                                                                }
                                                                            </>
                                                                        ) : (
                                                                            <ButtonComponent label='Set Configuration' type='button' fullWidth onClick={() => handleSetConfiguration(index)} disabled={values?.configurations?.[index]?.bins?.length === 0} />
                                                                        )
                                                                    }
                                                                    {
                                                                        touched.configurations?.[index] && errors?.configurations?.[index] !== undefined && (
                                                                            <FormError $fullwidth={true}>Please set configuration</FormError>
                                                                        )
                                                                    }
                                                                </FieldActions>
                                                            </FieldWrapper>

                                                            {
                                                                index !== values.configurations.length - 1 && (
                                                                    <HorizontalLine />
                                                                )
                                                            }
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </ConfigurationWrapper>
                                    )
                                }
                            </>
                        ) : (
                            <EmptyWrapper>
                                <EmptyModalComponent text={isDisabledAll ? 'No rules found!' : 'Please select institution first!'} />
                            </EmptyWrapper>
                        )
                    }

                    {
                        fromMakerChecker &&
                        <div>
                            <Label>Comments</Label>
                            <TextareaComponent
                                placeholder="Enter Comments"
                                onBlur={handleBlur}
                                name="reason"
                                value={values.reason}
                                onChange={handleChange}
                                rows={3}
                            />
                            {
                                touched.reason && errors.reason && (
                                    <FormError>{errors.reason}</FormError>
                                )
                            }
                        </div>
                    }

                    <ActionsContainer>
                        {fromMakerChecker ? (
                            <>
                                <ButtonComponent
                                    label="Reject"
                                    type="button"
                                    outline={true}
                                    color="error"
                                    onClick={() => handleAcceptReject(false)}
                                />
                                <ButtonComponent
                                    label={isChecker ? "Approve" : "Resend"}
                                    type="button"
                                    onClick={() => handleAcceptReject(true)}
                                />
                            </>
                        ) : (
                            <>
                                <ButtonComponent label={viewOnly ? 'Close' : 'Cancel'} type="button" outline={!viewOnly} onClick={close} />
                                {
                                    !viewOnly &&
                                    <ButtonComponent label={update ? "Update" : "Submit"} type="submit" onClick={handleSubmit} />
                                }
                            </>
                        )}
                    </ActionsContainer>
                </Form>
            </ModalComponent>

            {
                isOpenConfigurationModal && selectedConfigurationIndex !== null &&
                <AddUpdateRuleConfigurationModal data={values.configurations[selectedConfigurationIndex]} label="Set Configuration" close={() => setIsOpenConfigurationModal(false)} handleConfigurationSubmit={handleConfigurationSubmit} fromMakerChecker={fromMakerChecker} slide />
            }
        </>
    );
};

export default AddUpdateRuleEngineModal;